import { launchUrl } from '@office-start/launcher-service';
import { logFeature } from '@office-start/telemetry-service';
import { sanitizeUrlParameter } from '@office-start/url-parser-utility';
import { logAppHostError } from '../utils';
export const resolveOpenLink = (url, domain) => {
    try {
        const sanitizedUrl = sanitizeUrlParameter(url);
        const action = 'OpenInBrowser';
        const linkTarget = new URL(sanitizedUrl).origin === domain ? '_self' : '_blank';
        launchUrl(sanitizedUrl, { action, linkTarget });
        return true;
    }
    catch (error) {
        logAppHostError('Invalid_Open_Link_Url');
        return false;
    }
};
export class AppHostLinkService {
    constructor(domain) {
        this.domain = domain;
    }
    // TODO pokankan to add tests
    openLink(url) {
        logFeature({
            featureName: "MOSHub" /* KnownFeatureNames.MOSHub */,
            eventName: 'ExecuteDeepLink',
            params: {
                AppCapabilities: 'OpenLink',
                DebugInfo: `ExecuteDeepLink/OpenLink service`,
                Service: 'AppHostLinkService',
            },
            area: 'MOSAppHost',
            subArea: 'AppHostLinkService',
        });
        if (resolveOpenLink(url, this.domain)) {
            return Promise.resolve();
        }
        return Promise.reject();
    }
}
//# sourceMappingURL=AppHostLinkService.js.map